export enum PaymentStatus {
  PENDING = 'pending',
  PARTIAL = 'partial',
  PAID = 'paid',
  OVERDUE = 'overdue',
}

export enum PaymentMethod {
  CASH = 'cash',
  CARD = 'card',
  UPI = 'upi',
  NEFT = 'neft',
  RTGS = 'rtgs',
  IMPS = 'imps',
  CHEQUE = 'cheque',
  OTHER = 'other',
}

/**
 * Calculate stage status based on paid vs due amount
 */
export const calculateStageStatus = (
  paid: number,
  dueAmount: number,
  dueDate: Date,
): string => {
  if (paid >= dueAmount) return 'paid';

  // If any amount is paid but not fully paid, it's partial (even if past due date).
  if (paid > 0) return 'partial';

  // Nothing paid.
  return new Date() > dueDate ? 'overdue' : 'pending';
};

/**
 * Calculate overall payment status
 */
export const calculateOverallStatus = (stages): string => {
  if (stages.length === 0) return 'pending';

  const totalDue = stages.reduce((sum, stage) => sum + stage.dueAmount, 0);
  const totalPaid = stages.reduce((sum, stage) => sum + stage.paid, 0);

  if (totalPaid === 0) {
    const hasOverdue = stages.some(
      (stage) => stage.paid === 0 && new Date() > stage.dueDate,
    );
    return hasOverdue ? 'overdue' : 'pending';
  }

  if (totalPaid >= totalDue) return 'paid';

  const hasOverdue = stages.some(
    (stage) => stage.paid === 0 && new Date() > stage.dueDate,
  );

  return hasOverdue && totalPaid === 0 ? 'overdue' : 'partial';
};
